import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import Powerrank from './components/Powerrank';
import Interest from './components/Interest';
import InterestTrend from './components/InterestTrend';
import Passion from './components/Passion';
import Trust from './components/Trust';
import Presence from './components/Presence';
import PresenceTrend from './components/PresenceTrend';
import { selectDashboardEntries } from '../../redux/sonar/sonarSelectors';
import { Col, Panel, Row } from '../../components/layout/layout';

import './Dashboard.scss';

function Dashboard() {
  const { t } = useTranslation('sonar');

  const dashboardEntries = useSelector(selectDashboardEntries);

  return (
    <Col width={100} className='sonar-dashboard_content'>
      <Panel title={t('powerrank')}>
        <Powerrank domainEntries={dashboardEntries} />
      </Panel>
      <Row>
        <Col width={50}>
          <Panel title={t('interest')}>
            <Interest domainEntries={dashboardEntries} />
          </Panel>
        </Col>

        <Col width={50}>
          <Panel title={t('interestTrend')}>
            <InterestTrend domainEntries={dashboardEntries} />
          </Panel>
        </Col>
      </Row>

      <Panel title={t('passion')}>
        <Passion domainEntries={dashboardEntries} />
      </Panel>

      <Panel title={t('trust')}>
        <Trust domainEntries={dashboardEntries} />
      </Panel>

      <Row>
        <Col width={50}>
          <Panel title={t('presence')}>
            <Presence domainEntries={dashboardEntries} />
          </Panel>
        </Col>

        <Col width={50}>
          <Panel title={t('presenceTrend')}>
            <PresenceTrend domainEntries={dashboardEntries} />
          </Panel>
        </Col>
      </Row>
    </Col>
  );
}

export default Dashboard;
